import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

interface PeriodStats {
  sent: number
  delivered: number
  bounced: number
  complained: number
}

interface KeyUsage {
  key_id: string
  key_name: string
  key_type: string
  usage: {
    '7d': PeriodStats
    '30d': PeriodStats
    '90d': PeriodStats
  }
}

interface ApiKeyUsageResponse {
  data: KeyUsage[]
}

const QUERY_KEY = ['api-key-usage'] as const

export function useApiKeyUsage(): ReturnType<typeof useQuery<ApiKeyUsageResponse>> {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => apiClient.get<ApiKeyUsageResponse>(endpoints.apiKeys.usage),
  })
}

export type { ApiKeyUsageResponse, KeyUsage, PeriodStats }
